export const GROUP_DIAG_HEIGHT = '800px';
export const GROUP_DIAG_WIDTH = '1000px';